import _styled, { default as _styled2, default as _styled3 } from "styled-components";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import { useImpressionRef } from '@noths/polaris-client-react-hooks';
import { withScopedBaseStyles } from '@noths/polaris-client-ribbons-base';
import parse from 'html-react-parser';
import { trackBannerClick, trackBannerImpression } from "./tracking";
import * as styles from "./TopBanner.styles";
export var getInnerText = function getInnerText(ref) {
  return ref.current.innerText;
};
var Component = function Component(_ref) {
  var bgColor = _ref.bgColor,
    className = _ref.className,
    copyColor = _ref.copyColor,
    longCopy = _ref.longCopy,
    shortCopy = _ref.shortCopy;
  var smallScreenContainerRef = useImpressionRef(function () {
    trackBannerImpression(getInnerText(smallScreenContainerRef));
  });
  var mediumAndAboveScreenContainerRef = useImpressionRef(function () {
    trackBannerImpression(getInnerText(mediumAndAboveScreenContainerRef));
  });
  var parsedShortCopy = parse(shortCopy);
  var getClickHandler = function getClickHandler(ref) {
    return function (event) {
      var target = event.target;
      if (target.tagName === 'A') {
        trackBannerClick(event, getInnerText(ref), target.href);
      }
    };
  };
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    className: className,
    role: "banner",
    style: {
      '--topBannerBgColor': bgColor
    },
    $_css: styles.banner
  }, /*#__PURE__*/React.createElement(_StyledDiv2, {
    onClick: getClickHandler(smallScreenContainerRef),
    ref: smallScreenContainerRef,
    $_css2: [styles.shortCopy, styles.copyColor[copyColor]]
  }, parsedShortCopy), /*#__PURE__*/React.createElement(_StyledDiv3, {
    onClick: getClickHandler(mediumAndAboveScreenContainerRef),
    ref: mediumAndAboveScreenContainerRef,
    $_css3: [styles.longCopy, styles.copyColor[copyColor]]
  }, longCopy ? parse(longCopy) : parsedShortCopy));
};
export var TopBanner = withScopedBaseStyles(Component);
var _StyledDiv = _styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledDiv2 = _styled2("div")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledDiv3 = /*#__PURE__*/_styled3("div").withConfig({
  displayName: "TopBanner___StyledDiv3",
  componentId: "sc-1p19gyy-0"
})(["", ""], function (p) {
  return p.$_css3;
});